import { render, staticRenderFns } from "./userModal.vue?vue&type=template&id=18df8c8a&scoped=true&"
import script from "./userModal.vue?vue&type=script&lang=js&"
export * from "./userModal.vue?vue&type=script&lang=js&"
import style0 from "./userModal.vue?vue&type=style&index=0&id=18df8c8a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18df8c8a",
  null
  
)

export default component.exports